/* Saglou · búsqueda local y filtros progresivos. Los acordeones funcionan sin JS. */
(() => {
  function init(root) {
    if (root.dataset.sgfReady) return;
    const search = root.querySelector('[data-sgf-search]');
    const controls = root.querySelector('[data-sgf-tools]');
    const clear = root.querySelector('[data-sgf-clear]');
    const count = root.querySelector('[data-sgf-count]');
    const empty = root.querySelector('[data-sgf-empty]');
    const emptyText = root.querySelector('[data-sgf-empty-text]');
    const emptyDefault = emptyText && emptyText.textContent;
    const reset = root.querySelector('[data-sgf-reset]');
    const buttons = Array.from(root.querySelectorAll('[data-sgf-category]'));
    const groups = Array.from(root.querySelectorAll('[data-sgf-group]'));
    if (!search || !controls || !count || !empty) return;
    const normalise = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('es').trim();
    const items = Array.from(root.querySelectorAll('[data-sgf-item]')).map(element => ({
      element,
      category: element.closest('[data-sgf-group]').dataset.sgfGroup,
      text: normalise(element.textContent)
    }));
    let category = 'all';
    function render() {
      const words = normalise(search.value).split(/\s+/).filter(Boolean);
      let total = 0;
      items.forEach(item => {
        const visible = (category === 'all' || category === item.category) && words.every(word => item.text.includes(word));
        item.element.hidden = !visible;
        if (visible) total += 1;
      });
      groups.forEach(group => { group.hidden = !Array.from(group.querySelectorAll('[data-sgf-item]')).some(item => !item.hidden); });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sgfCategory === category)));
      clear.hidden = !search.value.length;
      empty.hidden = total !== 0;
      const selected = buttons.find(button => button.dataset.sgfCategory === category);
      const scope = category !== 'all' && selected ? ` en ${selected.textContent.trim()}` : '';
      count.textContent = `${total} ${total === 1 ? 'pregunta' : 'preguntas'}${scope}${words.length ? ' para tu búsqueda' : ''}`;
      if (reset) reset.textContent = category !== 'all' && words.length ? 'Buscar en todos los temas' : 'Ver todas las preguntas';
      if (emptyText) emptyText.textContent = category !== 'all' && words.length ? `No encontramos coincidencias en «${selected.textContent.trim()}». Puedes buscar en todos los temas sin perder lo que has escrito.` : emptyDefault;
    }
    buttons.forEach(button => button.addEventListener('click', () => { category = button.dataset.sgfCategory; render(); }));
    search.addEventListener('input', render);
    clear.addEventListener('click', () => { search.value = ''; render(); search.focus(); });
    if (reset) reset.addEventListener('click', () => {
      if (category !== 'all') category = 'all';
      else search.value = '';
      render(); search.focus();
    });
    root.dataset.sgfReady = 'true';
    controls.hidden = false;
    render();
  }
  function scan(scope) {
    if (scope.matches && scope.matches('[data-sgf]')) init(scope);
    scope.querySelectorAll('[data-sgf]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), {once:true});
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
